// NEW STYPEPARAMS METHOD
var CROP_ALIGNMENT = {
    CENTER: 'CENTER',
    TOP: 'TOP',
    LEFT: 'LEFT',
    RIGHT: 'RIGHT',
    BOTTOM: 'BOTTOM',
};
export default CROP_ALIGNMENT;
//# sourceMappingURL=layoutParams_crop_alignment.js.map